const React = require('react');
const Ripple = require('../Ripple');

module.exports = (props) => {
  return (
    <Ripple
      {...props}
      className={`h60 layoutRow ph20 tdN olN usN
        bg5B47FF bg5B47FF.75:not[.disabled]:h fhaC fvaC cF lh fw4 f16 ttU tn_all_0.2s_linear ov
        (o50|crNA).disabled*2 `
        + (props.className || '')}
    />
  );
};